import React, {useEffect} from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Episode from './Episode';
import MediaQuery from 'react-responsive';
import TrackData from './TrackData';
import { Parallax, ParallaxBanner, ParallaxBannerLayer } from 'react-scroll-parallax';
// import _ from 'lodash'
import {
  onAirFM, onAirZD
} from '~/programs/actions'
import { DateTime } from 'luxon';

const OnAirProgram = (props) => {
 
  const { dispatch, program, playlist, episode, title, height, onairnow, reverse } = props

  useEffect( () => {
    dispatch(onAirFM())
    dispatch(onAirZD())
  }, [])

  const cdn = '/'
  const onAirSlug = "/program/" + program.slug
  let image = ( episode && episode.imageUrl ) ? episode.imageUrl : (program.bannerImage) ? program.bannerImage : (program.profileImage) ? program.profileImage : cdn + 'assets/zedwall.jpg'


  let start = DateTime.fromFormat(program.start, 'tt')
  let end = start.plus({ seconds: program.duration })

  return (
    <div className="on-air-now">
      <div className="wrapper" style={{ height: height }}>
        <div style={{ height: '100vh', width: '100%'}} >
          <Parallax translateY={[-10, 10]}>
            <div style={{ backgroundImage: 'url('+image+')', backgroundPosition: 'center center', backgroundSize: 'cover', height: '100vh' }} className="show-banner"></div>
          </Parallax>
          {/* <ParallaxBannerLayer speed={-10}>
            <div style={{ backgroundImage: 'url('+image+')', width: '100%', height: '100%', backgroundSize: 'cover', backgroundPosition: 'center', filter: 'blur(5px)' }}>OK</div>
          </ParallaxBannerLayer> */}
          <div>
            <div className="inner" style={{height: height}}>
              <div className="program-status">
                <h2 className="on-air-title"><span>{title === 'On-air now!' && <i className="fa fa-circle faa-flash animated on-air-light"></i>}{title}</span></h2>
              </div>
              <img className="program-image" src={image} />
              <div className="program-notes">
                <Episode episode={ episode } program={ program } onairnow={title === 'On-air now!' ? "true" : "false"} />
                { onairnow && episode?.start && <TrackData style={{pointerEvents: 'all'}} episode={episode} playlist={playlist} onairnow={true} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default connect(state => ({programsFM: state.programsFM, onAirFM: state.onAirFM})) (OnAirProgram)
